import styled from 'styled-components';

import { Button } from 'components/Button';
import { Table } from 'components/Table';

const StyledTable = styled(Table)`
  padding: 3rem 0 3rem 4rem;
`;

const ActionBtn = styled(Button)`
  padding: 0.4rem;
  height: auto;
`;

const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { StyledTable, BtnWrapper, ActionBtn };
